import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable CRA's react-error-overlay in dev/preview.
// iOS Safari + some 3rd-party scripts emit opaque cross-origin
// "Script error." events that the overlay aggressively surfaces
// without any useful stack. These never affect end users (overlay
// does not exist in production builds). Real errors still log to
// the console and DevTools work normally.
if (process.env.NODE_ENV !== "production") {
  try {
    // eslint-disable-next-line global-require
    const overlay = require("react-error-overlay");
    if (overlay && typeof overlay.stopReportingRuntimeErrors === "function") {
      overlay.stopReportingRuntimeErrors();
    }
  } catch (_err) {
    /* react-error-overlay not installed — safe to ignore */
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
